import React from "react";
import { zl } from "../../../functions/utilities.js";

const MieszkaniecDaneWodaRozliczenieLegenda = props => {
    
    const { rozliczenieWodyAkt } = props;


    return (
        <div className="suma">
            <p>Legenda:</p>
            <table>
                <tbody>
                    <tr>
                        <td>
                            koszt zakupu zimnej wody (wg ceny PWiK):
                        </td>
                        <td>
                            {`${zl(rozliczenieWodyAkt?.metr_3_zimnej)} /m³`}
                        </td>
                    </tr>             
                    {
                        rozliczenieWodyAkt?.abonament_dzien > 0 && (
                            <tr>
                                <td>
                                    abonament (wyliczony wg faktur PEC):
                                </td>
                                <td>
                                    {`${zl(rozliczenieWodyAkt?.abonament_dzien)} /m² /dzień`}
                                </td>
                            </tr>
                        )
                    }      
                    <tr>
                        <td>
                            koszt podgrzania wody (wyliczony wg faktur PEC):
                        </td>
                        <td>
                            {`${zl(rozliczenieWodyAkt?.kosztPodgrzaniaCieplej)} /m³`}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenieLegenda;